import {
    Grid,
    SearchBar,
    SearchContext,
    SearchContextManager,
} from '@giphy/react-components'
import React from 'react'

import { Modal } from 'components/Modal'
import { reactionEventEmitter, reactionKeys } from 'helpers/events'

import { SearchBarContainer } from './styles'

const apiKey = process.env.REACT_APP_GIPHY_API_KEY

const searchOptions = {
    rating: 'g',
}

const styles = {
    modal: {
        maxWidth: 500,
        maxHeight: 600,
    },
}

const Components = ({ onGifClick }) => {
    const [isModalOpen, setIsModalOpen] = React.useState(false)

    const { fetchGifs, searchKey } = React.useContext(SearchContext)

    React.useEffect(() => {
        const handler = value => {
            setIsModalOpen(value)
        }

        reactionEventEmitter.addListener(
            reactionKeys.TRIGGER_GIPHY_MODAL,
            handler
        )

        return () => {
            reactionEventEmitter.removeListener(
                reactionKeys.TRIGGER_GIPHY_MODAL,
                handler
            )
        }
    }, [])

    const onCloseModal = () => {
        setIsModalOpen(false)
    }

    return (
        <Modal
            isModalOpen={isModalOpen}
            onCloseModal={onCloseModal}
            styles={styles}
            showCloseIcon={false}
        >
            <SearchBarContainer>
                <SearchBar />
            </SearchBarContainer>

            <Grid
                key={searchKey}
                columns={3}
                width={420}
                noLink
                fetchGifs={fetchGifs}
                onGifClick={onGifClick}
            />
        </Modal>
    )
}

const SearchExperience = ({ onGifClick }) => (
    <SearchContextManager
        apiKey={apiKey}
        initialTerm="reaction"
        options={searchOptions}
    >
        <Components onGifClick={onGifClick} />
    </SearchContextManager>
)

export { SearchExperience as GiphySearch }
